import amrFlag from "../../assets/images/amrFlag.jpg";
import chinaflag from "../../assets/images/chinaflag.jpg";
import denmarkflag from "../../assets/images/denmarkflag.jpg";
import estoniaFlag from "../../assets/images/estoniaFlag.png";
import finlandFlag from "../../assets/images/finlandFlag.png";
import Flag_of_Germany from "../../assets/images/Flag_of_Germany.svg";
import japanFlag from "../../assets/images/Flag_of_Japan.png";
import hongkongFLag from "../../assets/images/hongkongFlag.png";
import hungaryFlag from "../../assets/images/hungaryFlag.png";
import indFlag from "../../assets/images/indFlag.jpg";
import italyFlag from "../../assets/images/italyFlag.png";
import jurist0 from "../../assets/images/jurists/jurist0.png";
import jurist1 from "../../assets/images/jurists/jurist1.png";
import jurist10 from "../../assets/images/jurists/jurist10.png";
import jurist11 from "../../assets/images/jurists/jurist11.png";
import jurist12 from "../../assets/images/jurists/jurist12.png";
import jurist13 from "../../assets/images/jurists/jurist13.png";
import jurist14 from "../../assets/images/jurists/jurist14.png";
import jurist15 from "../../assets/images/jurists/jurist15.png";
import jurist16 from "../../assets/images/jurists/jurist16.png";
import jurist17 from "../../assets/images/jurists/jurist17.png";
import jurist18 from "../../assets/images/jurists/jurist18.png";
import jurist19 from "../../assets/images/jurists/jurist19.png";
import jurist2 from "../../assets/images/jurists/jurist2.png";
import jurist20 from "../../assets/images/jurists/jurist20.png";
import jurist21 from "../../assets/images/jurists/jurist21.png";
import jurist22 from "../../assets/images/jurists/jurist22.png";
import jurist23 from "../../assets/images/jurists/jurist23.png";
import jurist24 from "../../assets/images/jurists/Jurist24.png";
import jurist25 from "../../assets/images/jurists/Jurist25.png";
import jurist26 from "../../assets/images/jurists/jurist26.png";
import jurist27 from "../../assets/images/jurists/jurist27.png";
import jurist28 from "../../assets/images/jurists/jurist28.png";
import jurist29 from "../../assets/images/jurists/jurist29.png";
import jurist3 from "../../assets/images/jurists/jurist3.png";
import jurist30 from "../../assets/images/jurists/jurist30.png";
import jurist31 from "../../assets/images/jurists/jurist31.png";
import jurist4 from "../../assets/images/jurists/jurist4.png";
import jurist5 from "../../assets/images/jurists/jurist5.png";
import jurist6 from "../../assets/images/jurists/jurist6.png";
import jurist7 from "../../assets/images/jurists/jurist7.png";
import jurist8 from "../../assets/images/jurists/jurist8.png";
import jurist9 from "../../assets/images/jurists/jurist9.png";
import koreaflag from "../../assets/images/koreaflag.jpg";
import malaysiaFlag from "../../assets/images/malaysiaflag.png";
import russiaflag from "../../assets/images/russiaflag.jpg";
import singaporeFlag from "../../assets/images/singaporeFlag.png";
import taiwanFlag from "../../assets/images/taiwanFlag.jpg";
import turkeyFlag from "../../assets/images/turkeyFlag.png";
import venezuelaFlag from "../../assets/images/venezuelaFlag.png";

import { CountryConst } from "../CountryConst";

/**
 * Flag mapping based on CountryConst
 */
export const FLAG_MAP = {
    [CountryConst.DNMRK]: denmarkflag,
    [CountryConst.IDN]: indFlag,
    [CountryConst.KR]: koreaflag,
    [CountryConst.RSA]: russiaflag,
    [CountryConst.CHI]: chinaflag,
    [CountryConst.AMR]: amrFlag,
    [CountryConst.JP]: japanFlag,
    [CountryConst.ITL]: italyFlag,
    [CountryConst.FIN]: finlandFlag,
    [CountryConst.HUN]: hungaryFlag,
    [CountryConst.HK]: hongkongFLag,
    [CountryConst.SR]: singaporeFlag,
    [CountryConst.TRK]: turkeyFlag,
    [CountryConst.EST]: estoniaFlag,
    [CountryConst.TW]: taiwanFlag,
    [CountryConst.MYS]: malaysiaFlag,
    [CountryConst.GR]: Flag_of_Germany,
    [CountryConst.VN]: venezuelaFlag,
};

/**
 * Jurist List Data
 * To add a new jury member:
 * 1. Add their image to src/assets/images/jurists/
 * 2. Import it at the top of this file
 * 3. Add a new object to this array
 */
export const JURIST_LIST = (t) => [
    {
        image: jurist1,
        name: "CHRISTINE UTOMO",
        title: "Jurist 2023",
        quote: t("about10"),
        country: [CountryConst.IDN, CountryConst.CHI],
        link: "https://www.instagram.com/p/CpcHUoUPkeM/?igsh=MXV6ZXl0cG5jNXR4aw%3D%3D&img_index=6"
    },
    {
        image: jurist2,
        name: "ISWARGIA SUDARNO",
        title: "Jurist 2023",
        quote: t("about11"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/CpcHUoUPkeM/?igsh=MXV6ZXl0cG5jNXR4aw%3D%3D&img_index=8"
    },
    {
        image: jurist3,
        name: "MYRA K PRANAJAYA",
        title: "Jurist 2023",
        quote: t("about12"),
        country: [CountryConst.IDN, CountryConst.DNMRK],
        link: "https://www.instagram.com/p/CpcHUoUPkeM/?igsh=MXV6ZXl0cG5jNXR4aw%3D%3D&img_index=10"
    },
    {
        image: jurist4,
        name: "AMELIA SANTOSO",
        title: "Jurist 2022",
        quote: t("about13"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/Cb4RXpGL4Gf/?igsh=MTIweG85aG83ejFqcw%3D%3D"
    },
    {
        image: jurist5,
        name: "NADYA JANITRA",
        title: "Jurist 2023",
        quote: t("about8"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/CvEvFaOSOPl/?igsh=MW41bzh6cmp4NDl0&img_index=2"
    },
    {
        image: jurist0,
        name: "FIRDY SALIM",
        title: "Jurist 2022, 2023, 2024, 2025",
        quote: t("about9"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/CvEvFaOSOPl/?igsh=MW41bzh6cmp4NDl0&img_index=3"
    },
    {
        image: jurist7,
        name: "MARTIN KESUMA",
        title: "Jurist 2024 & 2025",
        quote: t("about15"),
        country: [CountryConst.IDN, CountryConst.AMR],
        link: "https://www.instagram.com/p/C4pZ41uvxCp/?igsh=MW1pd2tuYWpsN29haw%3D%3D&img_index=5"
    },
    {
        image: jurist6,
        name: "CARLA SUHARTO",
        title: "Jurist 2024",
        quote: t("about14"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/C4pZ41uvxCp/?igsh=MW1pd2tuYWpsN29haw%3D%3D&img_index=3"
    },
    {
        image: jurist10,
        name: "CHIKITA AMANDA",
        title: "Jurist 2023",
        quote: t("about7"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/CvRD0tYhJI8/?igsh=eTZsd21ieXd3eGJ0&img_index=2"
    },
    {
        image: jurist8,
        name: "MICHELLE K BAHARI",
        title: "Jurist 2023",
        quote: t("about16"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/CpcHUoUPkeM/?igsh=MXV6ZXl0cG5jNXR4aw%3D%3D&img_index=5"
    },
    {
        image: jurist9,
        name: "RM CONDRO KASMOYO",
        title: "Jurist 2023",
        quote: t("about17"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/CvRD0tYhJI8/?igsh=eTZsd21ieXd3eGJ0&img_index=3"
    },
    {
        image: jurist11,
        name: "NOZOMI HIWATASHI",
        title: "Jurist 2025,2026",
        quote: t("about19"),
        country: [CountryConst.JP],
        link: "https://www.instagram.com/p/DJtLrHZBUOo/?img_index=3&igsh=MXJ3NXdncTA3c3pqdQ%3D%3D"
    },
    {
        image: jurist12,
        name: "AARON KURZ",
        title: "Jurist 2025,2026",
        quote: t("about20"),
        country: [CountryConst.AMR],
        link: "https://www.instagram.com/p/DJW1yq4Bj34/?img_index=2&igsh=MTlrcWpjNW53cjdxMQ%3D%3D"
    },
    {
        image: jurist13,
        name: "DR. JIN YUN",
        title: "Jurist 2025,2026",
        quote: t("about21"),
        country: [CountryConst.KR],
        link: "https://www.instagram.com/p/DJqT3uUBAP-/?igsh=MW1mYmsyZjg2cTR5NA%3D%3D&img_index=3"
    },
    {
        image: jurist14,
        name: "LIVIA SCHWEIZER",
        title: "Jurist 2025,2026",
        quote: t("about22"),
        country: [CountryConst.ITL, CountryConst.FIN],
        link: "https://www.instagram.com/p/DJqT3uUBAP-/?igsh=MW1mYmsyZjg2cTR5NA%3D%3D&img_index=3"
    },
    {
        image: jurist15,
        name: "HSIEH MENG FU",
        title: "Jurist 2025,2026",
        quote: t("about23"),
        country: [CountryConst.TW],
        link: "https://www.instagram.com/p/DJqT3uUBAP-/?igsh=MW1mYmsyZjg2cTR5NA%3D%3D&img_index=3"
    },
    {
        image: jurist16,
        name: "András Dénes",
        title: "Jurist 2025,2026",
        quote: t("about24"),
        country: [CountryConst.HUN],
        link: "https://www.instagram.com/p/DKgWHIhhL-E/?img_index=2"
    },
    {
        image: jurist17,
        name: "Bálint Képiró",
        title: "Jurist 2025,2026",
        quote: t("about25"),
        country: [CountryConst.HUN],
        link: "https://www.instagram.com/p/DKgWHIhhL-E/?img_index=3"
    },
    {
        image: jurist18,
        name: "Theduardo Prasetyo",
        title: "Jurist 2025,2026",
        quote: t("about26"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/DKgRu_KBOGO/?img_index=2"
    },
    {
        image: jurist19,
        name: "YIFEI PEI",
        title: "Jurist 2025,2026",
        quote: t("about27"),
        country: [CountryConst.CHI],
        link: "https://www.instagram.com/p/DKgRu_KBOGO/?img_index=3"
    },
    {
        image: jurist20,
        name: "KAREN TAY",
        title: "Jurist 2025,2026",
        quote: t("about29"),
        country: [CountryConst.SR],
        link: "https://www.instagram.com/p/DJ_bzFdhHr2/?img_index=2"
    },
    {
        image: jurist21,
        name: "NATALIE LO",
        title: "Jurist 2025,2026",
        quote: t("about28"),
        country: [CountryConst.HK],
        link: "https://www.instagram.com/p/DJ_bzFdhHr2/?img_index=3"
    },
    {
        image: jurist23,
        name: "Vahur Luhtsalu",
        title: "Jurist 2025",
        quote: t("about30"),
        country: [CountryConst.EST],
        link: "https://www.instagram.com/p/DKyvVwTBS-h/?img_index=3"
    },
    {
        image: jurist22,
        name: "Öykü Melis Şahin",
        title: "Jurist 2025,2026",
        quote: t("about31"),
        country: [CountryConst.TRK],
        link: "https://www.instagram.com/p/DKyvVwTBS-h/?img_index=2"
    },
    {
        image: jurist24,
        name: "Jennifer Tan",
        title: "Jurist 2025,2026",
        quote: t("about32"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/DKr4wOFB4_O/?img_index=2"
    },
    {
        image: jurist25,
        name: "Jessica januar",
        title: "Jurist 2025,2026",
        quote: t("about33"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/DKr4wOFB4_O/?img_index=3"
    },
    {
        image: jurist26,
        name: "Yvonne Tay",
        title: "Jurist 2026",
        quote: t("about34"),
        country: [CountryConst.SR],
        link: "https://www.instagram.com/p/DWitcARmM_8/?img_index=3"
    },
    {
        image: jurist27,
        name: "Sara Heng",
        title: "Jurist 2026",
        quote: t("about35"),
        country: [CountryConst.MYS],
        link: "https://www.instagram.com/p/DWitcARmM_8/?img_index=2"
    },
    {
        image: jurist28,
        name: "Pok Chee Hong",
        title: "Jurist 2026",
        quote: t("about36"),
        country: [CountryConst.MYS],
        link: "hhttps://www.instagram.com/p/DWiRn_4mEO6/?img_index=3"
    },
    {
        image: jurist29,
        name: "Catherine Wong",
        title: "Jurist 2026",
        quote: t("about37"),
        country: [CountryConst.HK],
        link: "https://www.instagram.com/p/DW09_DxGM1X/?img_index=2"
    },
    {
        image: jurist30,
        name: "Dionisius Clyde",
        title: "Jurist 2026",
        quote: t("about38"),
        country: [CountryConst.IDN],
        link: "https://www.instagram.com/p/DWiRn_4mEO6/?img_index=2"
    },
    {
        image: jurist31,
        name: "Daniel Arias",
        title: "Jurist 2026",
        quote: t("about39"),
        country: [CountryConst.VN],
        link: "https://www.instagram.com/p/DXZbR0MmHJW/?img_index=2"
    },
];
